import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { DestinationPlatform } from 'blocks/DestinationPlatforms';
import LinkButton from 'components/LinkButton';
import Modal, { ModalHeader } from 'components/Modal/v2';
import ModalFooter from 'components/Modal/v2/ModalFooter';
import {
  BlueskyButton,
  FacebookButton,
  InstagramButton,
  LinkedInButton,
  ThreadsButton,
  TikTokButton,
  TwitterButton,
  YouTubeButton,
} from 'components/SocialButton';
import { onClickAudiogramDestinationModal } from 'redux/modules/mixpanel';
import { hideModal, replaceModal } from 'redux/modules/modal';
import { Dispatch } from 'redux/types';
import { DESTINATION_ID_TO_MIXPANEL_DESTINATION_MAP } from './constants';
import { chooseDestinationContentsBlock as block } from './utils';

export interface ChooseDestinationModalContentsProps {
  onDestinationClick?: (destination: DestinationPlatform) => void;
}

const ChooseDestinationModalContents: React.FC<ChooseDestinationModalContentsProps> = ({
  onDestinationClick,
}) => {
  const dispatch = useDispatch<Dispatch>();
  const handleHide = useCallback((): void => {
    dispatch(hideModal());
  }, [dispatch]);

  const handleOnClickDestination = useCallback(
    (dest: DestinationPlatform): void => {
      dispatch(
        onClickAudiogramDestinationModal(
          DESTINATION_ID_TO_MIXPANEL_DESTINATION_MAP[dest],
        ),
      );
    },
    [dispatch],
  );

  const createClickHandler = (dest: DestinationPlatform) => () => {
    handleOnClickDestination(dest);
    onDestinationClick?.(dest);
  };

  const handleOldOptionsClick = () => {
    dispatch(onClickAudiogramDestinationModal('OldOptions'));
    dispatch(replaceModal({ name: 'ManualAudiogram' }));
  };

  return (
    <Modal
      header={
        <ModalHeader
          className={block('header')}
          onHide={handleHide}
          title="Choose a destination"
          subtitle="Where would you like to promote your podcast?"
        />
      }
      footer={
        <ModalFooter className={block('footer')}>
          <LinkButton
            onClick={handleOldOptionsClick}
            theme="cta"
            uppercase
            size="md"
          >
            I’m not sure, show me the old options
          </LinkButton>
        </ModalFooter>
      }
    >
      <div className={block('grid')}>
        <YouTubeButton onClick={createClickHandler('youtube')} />
        <InstagramButton onClick={createClickHandler('instagram')} />
        <FacebookButton onClick={createClickHandler('facebook')} />
        <TikTokButton onClick={createClickHandler('tiktok')} />
        <LinkedInButton onClick={createClickHandler('linkedin')} />
        <ThreadsButton onClick={createClickHandler('threads')} />
        <TwitterButton onClick={createClickHandler('twitter')} />
        <BlueskyButton onClick={createClickHandler('bluesky')} />
      </div>
    </Modal>
  );
};

export default ChooseDestinationModalContents;
